import React, { Component } from "react";
import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import Popup from "reactjs-popup";

import NotificationSystem from "react-notification-system";
import { style, deploymentEnvironment } from "variables/Variables.jsx";

import { customLog, planToNumber } from "../../variables/Variables";
import {
  getCustomerIdAndName,
  updateGroupAccounts,
  createPlanSubscription,
  updateExistingGroupAccounts,
  updateUserDetails,
  getToday,
} from "./SubscriptionManagementHelper";

import { fire, auth } from "../../firebase/index";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    changeCardInfo: "Change Payment Method",
    updateCardInfo: "Update Card Info",
    changePaymentCardTitle: "Change payment card",
    nameOnCardTitle: "Name on Card",
    billingAddressTitle: "Billing Address",
    submitBtnTitle: "Submit",
    cardChargeMessageTitle:
      "*Your card will only be charged at the end of the subscription month*",
    changeCardError: "Fail to change card. Please try again !",
    changeCardSuccess: "Card has been updated !",
    changeCardInvalid: "Invalid card, Please try again !",
    updatingCardMessage: "Updating card information....",
    updatingCardmessageSuccess: "Succesfully updated card !",
  },
  ja: {
    changeCardInfo: "登録クレジットカードを変更",
    updateCardInfo: "クレジットカード情報入力",
    changePaymentCardTitle: "クレジットカードを変更する",
    nameOnCardTitle: "カード名義",
    billingAddressTitle: "請求先住所 ※日本のクレジットカードは入力不要",
    submitBtnTitle: "申し込む",
    cardChargeMessageTitle:
      "*クレジットカードへのご請求は月毎になります（クレジットカード会社により締日は異なります）。",
    changeCardError: "カードの変更に失敗しました。もう一度お試しください！",
    changeCardSuccess: "カードが更新されました！",
    changeCardInvalid: "無効なカードです。もう一度お試しください！",
    updatingCardMessage: "カード情報を更新中....",
    updatingCardmessageSuccess: "カードが正常に更新されました！",
  },
  es: {
    changeCardInfo: "Cambiar Método de Pago",
    updateCardInfo: "Actualizar Información de la Tarjeta",
    changePaymentCardTitle: "Cambiar tarjeta de pago",
    nameOnCardTitle: "Nombre en la Tarjeta",
    billingAddressTitle: "Dirección de Facturación",
    submitBtnTitle: "Enviar",
    cardChargeMessageTitle:
      "*Su tarjeta solo se cargará al final del mes de suscripción*",
    changeCardError:
      "Error al cambiar la tarjeta. ¡Por favor, inténtelo de nuevo!",
    changeCardSuccess: "¡La tarjeta ha sido actualizada!",
    changeCardInvalid: "Tarjeta inválida, ¡Por favor, inténtelo de nuevo!",
    updatingCardMessage: "Actualizando la información de la tarjeta....",
    updatingCardmessageSuccess: "¡Tarjeta actualizada con éxito!",
  },
});

// const override = {
//   display: "block",
//   margin: "0 auto",
//   borderColor: "red"
// };

class ChangeCardElement extends Component {
  constructor(props) {
    super(props);
    this.popupForm = this.popupForm.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.editCardDetails = this.editCardDetails.bind(this);
    this.changeDetailsSubmit = this.changeDetailsSubmit.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.getPlanName = this.getPlanName.bind(this);

    this.state = {
      open: false,
      customerStripeId: "",
      loading: false,
      _notificationSystem: null,
      access: {},
      currentLanguage: localizationStrings.getLanguage(),
    };
  }
  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid)
        .child("payment")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            const specialTrialMode = data.specialTrialMode;
            const subId = data.stripeSubscriptionId;
            const trialEndDate = data.trialEndDate;
            // customLog(data.payment.isPaymentValid);

            this.setState({
              stripeSubscriptionId: subId,
              specialTrialMode: specialTrialMode,
              existingPlan: true,
              currentPlan: data.plan,
              planSelected: data.plan,
              planId: data.currentPlanId,
              currentPlanType: data.planType,
              annualPayment: data.planType === "ANNUAL" ? true : false,
              trialEndDate: data.trialEndDate,
              access: data,
            });
          }
        });

      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }
  closeModal() {
    this.setState({ open: false });
  }

  editCardDetails() {
    this.setState({ open: true });
  }

  showNotification(msg, level) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: msg,
      level: level,
      position: "tc",
      autoDismiss: 10,
    }); //End of notificat
  }

  async getPlanName(planSelected) {
    await fire
      .database()
      .ref("subscriptionPackageDetail")
      .child("PLANS")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((snap) => {
          if (snap.val().plan === planSelected) {
            return snap.val().packageName;
          }
        });
      });
  }

  //Check if the user has an active subscription, if not create one which pays after the trial ends
  //if both not found (dateLastPayment & subscription id), create subscription
  async changeDetailsSubmit() {
    const creditCardName = document.getElementById("creditCardName").value;
    const creditCardAddr = document.getElementById("creditCardAddr").value;

    const { dataCallBack } = this.props;
    this.setState({ loading: true });

    if (this.state.access.specialTrialMode) {
      this.showNotification(localizationStrings.updatingCardMessage, "warning");

      await this.props.stripe
        .createPaymentMethod({
          type: "card",
          card: this.props.elements.getElement(CardElement),
          billing_details: {
            name: creditCardName,
            address: { line1: creditCardAddr },
          },
        })
        .then(async (result) => {
          customLog(result);
          customLog(result.paymentMethod.id);

          const dataToPost = {
            paymentMethodId: result.paymentMethod.id,
            email: auth.currentUser.email,
            planName: await this.getPlanName(this.state.planSelected),
            planPrice: this.state.planPrice,
            planType: this.state.annualPayment ? "year" : "month",
            planId: this.state.planId,
            currentUid: auth.currentUser.uid,
            trialEndDate: this.state.trialEndDate,
            language: this.state.currentLanguage,
          };

          await createPlanSubscription(dataToPost, async (callback) => {
            if (!callback) {
              customLog("Failed");
            } else {
              if (callback.requiresAction && callback.clientSecret) {
                const confirm =
                  callback.intentType === "setup"
                    ? await this.props.stripe.confirmCardSetup(
                        callback.clientSecret
                      )
                    : await this.props.stripe.confirmCardPayment(
                        callback.clientSecret
                      );

                if (confirm.error) {
                  this.setState({ loading: false });
                  this.showNotification(
                    localizationStrings.changeCardInvalid,
                    "error"
                  );
                  return;
                }
                // 3DS authentication succeeded — treat the same as an immediate success
                callback.message = "Subscribed";
              }

              //? The Value that is sent back by firebase cloud function.
              if (callback.message === "Subscribed") {
                let stripeSubId = callback.response.id;
                let stripeCustomerId = callback.response.customer;
                let planNumber,
                  planType,
                  planId,
                  maxUser,
                  maxLock,
                  maxTag,
                  maxMulti;
                let planToNumberResponse = planToNumber(
                  this.state.planSelected
                );
                planNumber = planToNumberResponse.planNumber;
                planType = this.state.annualPayment ? "ANNUAL" : "MONTHLY";
                planId = this.state.annualPayment
                  ? planToNumberResponse.annualPlanId
                  : planToNumberResponse.planId;
                maxUser = planToNumberResponse.maxUsers;
                maxLock = planToNumberResponse.maxLocks;
                maxTag = planToNumberResponse.maxTags;
                maxMulti = planToNumberResponse.maxMulti;

                customLog(creditCardAddr);
                customLog(creditCardName);

                this.setState({
                  loading: false,
                  stripeSubscriptionId: stripeSubId,
                });

                // Update DB:
                const paidDate = callback.response.current_period_start;
                const customerId = callback.response.customer;
                const planSelected = this.state.planSelected;

                const cardLastFour = result.paymentMethod.card.last4;
                const cardExpMonth = result.paymentMethod.card.exp_month;
                const cardExpYear = result.paymentMethod.card.exp_year;
                const cardExp = cardExpMonth + "/" + cardExpYear;

                let today;
                getToday((response) => {
                  today = response;
                });

                let dbPayments = {
                  currentPaymentType: "STRIPE",
                  currentPlanId: planId,
                  currentRedemptionActiveCode: "",
                  dateLastPayment: paidDate,
                  isPaymentValid: true,
                  maxUsers: maxUser,
                  maxTags: maxTag,
                  maxLocks: maxLock,
                  maxMulti: maxMulti,
                  plan: planNumber,
                  planType: planType,
                  specialTrialMode: false,
                  startMonthlyCycle: today,
                  startedOn: paidDate,
                  trialEndDate: this.state.trialEndDate,
                  onTrialPeriod: true,
                  stripeSubscriptionId: stripeSubId,
                  stripeCustomerId: stripeCustomerId,
                  cardName: creditCardName,
                  billingAddr: creditCardAddr,
                  cardLastFourDigit: cardLastFour,
                  cardExp: cardExp,
                };

                //update payment details
                customLog("Updating payment details...");

                await updateExistingGroupAccounts(
                  dbPayments,
                  async (callback) => {
                    if (callback) {
                      await updateUserDetails(
                        paidDate,
                        customerId,
                        planSelected
                      );
                    }
                  }
                );

                this.showNotification(
                  localizationStrings.updatingCardmessageSuccess,
                  "success"
                );
                this.closeModal();
              }
            }
          });
        })
        .catch((err) => {
          customLog(err);
          this.setState({ loading: false });
          this.showNotification(localizationStrings.changeCardInvalid, "error");
        });
    } else {
      await this.props.stripe
        .createPaymentMethod({
          type: "card",
          card: this.props.elements.getElement(CardElement),
          billing_details: {
            name: creditCardName,
            address: { line1: creditCardAddr },
          },
        })
        .then(async (result) => {
          this.closeModal();
          customLog(result);
          customLog(result.paymentMethod.id);

          await getCustomerIdAndName(async (res) => {
            if (res.status === "ok") {
              const dataToPost = {
                paymentMethodId: result.paymentMethod.id,
                cusId: res.cusId,
              };

              let url = "";

              if (deploymentEnvironment) {
                url =
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/changeLiveCreditCard3DS";
              } else {
                url =
                  "https://us-central1-egeetouchindustrial.cloudfunctions.net/changeTestCreditCard3DS";
              }

              let response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(dataToPost),
              }).catch((err) => {
                customLog(err);
                this.showNotification(
                  localizationStrings.changeCardError,
                  "error"
                );
              });

              const cardLastfour = result.paymentMethod.card.last4;
              const cardExpMonth = result.paymentMethod.card.exp_month;
              const cardExpYear = result.paymentMethod.card.exp_year;
              const cardExp = cardExpMonth + "/" + cardExpYear;

              customLog(response);

              if (response.ok) {
                await updateGroupAccounts(
                  creditCardName,
                  creditCardAddr,
                  cardLastfour,
                  cardExp
                );

                this.setState(
                  {
                    loading: false,
                    open: false,
                  },
                  () => {
                    this.showNotification(
                      localizationStrings.changeCardSuccess,
                      "success"
                    );

                    const dataToCallBackToParent = {
                      cardLastFour: cardLastfour,
                      cardExp: cardExp,
                    };
                    dataCallBack(dataToCallBackToParent);
                  }
                );
              } else {
                this.showNotification(
                  localizationStrings.changeCardError,
                  "error"
                );
              }
            }
          });
        })
        .catch((err) => {
          customLog(err);
          this.setState({ loading: false });
          this.showNotification(localizationStrings.changeCardInvalid, "error");
        });
    }
  }

  popupForm() {
    return (
      <div>
        <a className="close" onClick={this.closeModal}>
          &times;
        </a>
        <h2 id="planNameSelected">
          {localizationStrings.changePaymentCardTitle}
        </h2>
        <div>
          <label className="cardLabel">
            {localizationStrings.nameOnCardTitle}
          </label>
          <input
            className={"stripeBtn-inputText"}
            type="text"
            id="creditCardName"
            // placeholder="Name on Card"
            required
          />
          <label className="cardLabel">
            {localizationStrings.billingAddressTitle}
          </label>
          <input
            className={"stripeBtn-inputText"}
            type="text"
            id="creditCardAddr"
            // placeholder="Billing Address"
            required
          />
          <div id="planSelectedCredentialKey">
            <CardElement
              options={{
                hidePostalCode: true,
                style: { base: { fontSize: "18px" } },
              }}
            />
          </div>
          <span id="paymentError" style={{ color: "red" }}>
            {this.state.errorMessage}
          </span>
          <button id="paymentConfirmBtn" onClick={this.changeDetailsSubmit}>
            {localizationStrings.submitBtnTitle}
          </button>
          <label style={{ marginLeft: "1.7em" }}>
            {localizationStrings.cardChargeMessageTitle}
          </label>
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Popup
          open={this.state.open}
          closeOnDocumentClick
          className="planPopup"
          onClose={this.closeModal}
          children={this.popupForm}
        />

        <button className={"changeSubBtn"} onClick={this.editCardDetails}>
          {this.state.access.specialTrialMode
            ? localizationStrings.updateCardInfo
            : localizationStrings.changeCardInfo}
        </button>
      </div>
    );
  }
}

export default function ChangeCardElementWrapper(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <ChangeCardElement {...props} stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}
